<template>
  <vue-modal :active="active" type="small" @closed="$emit('closed')">
    <cart-product-form :model="data" @updated="handleUpdated"/>
  </vue-modal>
</template>

<script>
import CartProductForm from './CartProductForm.vue';
import modal from '../../mixins/modal';

export default {
  mixins: [modal],

  components: { CartProductForm },

  methods: {
    handleUpdated(cart) {
      Event.fire('cartUpdated', cart);
    },
  },
};
</script>